import React, {useEffect, useState} from 'react';
import {useHistory} from "react-router-dom";
import {projectStartSearch} from "../../../utils/projectStartSearch"
import PacefiFullScreenSpinner from "../../theme/loaders/pacefiFullScreenSpinner";


 function ProjectLandingRedirect(props) {
    const history = useHistory()

    useEffect(() => {
        let address = new URLSearchParams(window.location.search).get(
            'a'
        );
        projectStartSearch(address, history)
    }, [])


    return <div>
        <h4>Redirecting...</h4>
    </div>
}

export default ProjectLandingRedirect;